module.exports = __webpack_public_path__ + "static/media/charity.3c3779f6.webp";